import { useDataProvider, useNotify, useRefresh, useTranslate } from 'react-admin';

interface SyncNatsResponse {
  success: boolean;
  message: string;
  bucket: string;
  syncedCount: number;
  total: number;
  errors?: Array<{
    rpcId?: string;
    error?: string;
  }>;
}

export const useSyncNats = () => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const translate = useTranslate();

  const handleSync = async (resource: string) => {
    try {
      const response = await dataProvider.create(`${resource}/sync-nats`, { data: {} });
      const data: SyncNatsResponse = response.data || response;
      
      data.success ? 
      notify(
        `${translate('module.natsSync.syncSuccess')} ${data.bucket} (${data.syncedCount}/${data.total})`, { type: 'success' }
      ) : 
      notify(
        `${translate('module.natsSync.syncFailed')} ${data.bucket} (${data.syncedCount}/${data.total})`, { type: 'error' }
      );
      refresh();
      return data;
    } catch (error: any) {
      const errorMessage = error?.body?.message || error?.message || 'Sync failed';
      notify(errorMessage, { type: 'error' });
      throw error;
    }
  };

  return { handleSync };
};